<template>
  <div id="agreed-review">
    <div class="ipub-h1 line-h-40  mar-b-12">
      Review Report
    </div>
    <div class="content-bg mar-b-20"
         style="padding-bottom:8px">
      <div>
        <div class="ipub-h3 line-h-40 ipub-title-tab mar-b-10"
             @click="()=>{showManuscript=!showManuscript}">Manuscript Information
          <ipub-icon :class="['ipub-p5 mar-l-20 rotate ipub-cursor-pointer',!showManuscript?'rotate-180':'']"
                     type="iconArrow" />
        </div>
        <div class="mar-b-20 ipub-title-tab-part"
             v-if="!showManuscript">
          <div class="mar-b-12 ipub-p2">
            <span class="fw-bd ipub-block__span">Manuscript No.</span>
            <span class="ipub-block__font">{{reviewsResponse.code}}</span>
          </div>
          <div class="mar-b-12 ipub-p2">
            <span class="fw-bd ipub-block__span">Article Type</span>
            <span class="ipub-block__font">{{reviewsResponse.type && reviewsResponse.type.name}}</span>
          </div>
          <div class="mar-b-12 ipub-p2">
            <span class="fw-bd ipub-block__span">Journal</span>
            <span class="ipub-block__font">{{reviewsResponse.journal && reviewsResponse.journal.fullName}}</span>
          </div>
          <div class="mar-b-12 ipub-p2">
            <span class="fw-bd ipub-block__span">Article Title</span>
            <span class="ipub-block__font">{{reviewsResponse.title}}</span>
          </div>
          <div class="ipub-p2 flex">
            <span class="fw-bd ipub-block__span"
                  style="line-height:30px">Attachment(s)</span>&nbsp;
            <div class="ipub-block__font"
                 v-if="reviewsResponse.reviewFileList && reviewsResponse.reviewFileList.length">
              <ipub-label style="margin-right:12px"
                          type="link"
                          class="ipub-p2 ipub-c-p"
                          v-for="(item,index) in reviewsResponse.reviewFileList"
                          :key="item.id"
                          @click="download(item,index)">
                {{item.name}}
                <ipub-icon class="mar-l-10 ipub-p2"
                           type="iconDownload1" />
              </ipub-label>
            </div>
          </div>
        </div>
      </div>

      <div v-if="reviewsResponse.reportList && reviewsResponse.reportList.length>0">
        <div class="mar-b-20"
             :key="itemrep.id"
             v-for="(itemrep,indexrep) in reviewsResponse.reportList">
          <div class="ipub-h3 line-h-40 mar-b-12 ipub-title-tab"
               @click="togalReport(itemrep,'showReport')">
            Report {{reviewsResponse.reportList.length-indexrep}} ({{articalStatus[itemrep.decisionStatus]}})
            <ipub-icon :class="['ipub-p5 mar-l-20 rotate ipub-cursor-pointer',!itemrep.showReport?'rotate-180':'']"
                       type="iconArrow" />
          </div>
          <div v-show="!itemrep.showReport"
               class="ipub-title-tab-part">
            <div class="ipub-p2 fw-bd mar-b-12">
              Overall Quality Evaluation
            </div>
            <div class="question-answer">
              <customerReviewQuestion :questionList="itemrep.questionList"></customerReviewQuestion>
            </div>
            <div class="mar-b-20">
              <div class="ipub-p2 fw-bd fw-bd line-h-40  mar-b-5">
                Comments to Author
                <ipub-icon :class="['ipub-p5 mar-l-20 rotate ipub-cursor-pointer',!itemrep.commentsAuthor?'rotate-180':'']"
                           @click="togalReport(itemrep,'commentsAuthor')"
                           type="iconArrow" />
              </div>
              <div v-if="!itemrep.commentsAuthor">
                <div class="ipub-p2"
                     v-if="itemrep.authorNotes"
                     v-html=" itemrep.authorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
                <template v-else>
                  <div class="line-color">No notes or comments.</div>
                </template>

              </div>

            </div>
            <div class="mar-b-20">
              <div class="ipub-p2 fw-bd fw-bd line-h-40  mar-b-5">
                Comments to Editor
                <ipub-icon :class="['ipub-p5 mar-l-20 rotate ipub-cursor-pointer',!itemrep.commentsEditor?'rotate-180':'']"
                           @click="togalReport(itemrep,'commentsEditor')"
                           type="iconArrow" />
              </div>
              <div v-if="!itemrep.commentsEditor">

                <div class="ipub-p2"
                     v-if="itemrep.editorNotes"
                     v-html=" itemrep.editorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
                <template v-else>
                  <div class="line-color">No notes or comments.</div>
                </template>

              </div>

            </div>
            <div class=" mar-b-10"
                 v-show="itemrep.reviewerFileList && itemrep.reviewerFileList.length>0">
              <div class="ipub-p2 fw-bd mar-b-10">
                Attachment(s)
              </div>
              <div class="flex ipub-p2">
                <ipub-label class="mar-b-10"
                            hover
                            style="margin-right:12px"
                            @click="download(itemfile,indexfile)"
                            :key="indexfile"
                            v-for="(itemfile,indexfile) in itemrep.reviewerFileList">
                  <span class="ipub-p2">{{itemfile.name}} </span>
                  <ipub-icon type="iconDownload1"
                             class="mar-l-10" />
                </ipub-label>
              </div>
            </div>
            <div class="ipub-line mar-b-20"
                 v-if="itemrep.authorReply || itemrep.authorReplyFileList && itemrep.authorReplyFileList.length>0"></div>
            <div v-if="itemrep.authorReply"
                 class="mar-b-20">
              <div class="ipub-p2 fw-bd mar-b-10">
                Author’s Response to Report {{reviewsResponse.reportList.length - indexrep}}
              </div>
              <div class="ipub-p2 fw-bd mar-b-10">Author’s Response</div>
              <div class="ipub-p2"
                   v-html="itemrep.authorReply && itemrep.authorReply.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
            </div>
            <div class="mar-b-10"
                 v-show="itemrep.authorReplyFileList && itemrep.authorReplyFileList.length>0">
              <div class="ipub-p2 fw-bd mar-b-10">
                Author’s Response File
              </div>
              <div class="flex">
                <ipub-label class="mar-b-10"
                            hover
                            v-show="itemauth.authorShowed"
                            style="margin-right:10px;cursor:pointer"
                            @click="download(itemauth,indexauth)"
                            :key="itemauth.id"
                            v-for="(itemauth,indexauth) in itemrep.authorReplyFileList">
                  <span class="ipub-cursor-pointer ipub-p2">{{itemauth.name}} </span>
                  <ipub-icon type="iconDownload1"
                             class="mar-l-10" />
                </ipub-label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="ipub-h3 line-h-40 mar-b-8 ipub-title-tab"
             @click="showReview = !showReview">
          Report {{reviewsResponse.reportList.length +1}}
          <ipub-icon :class="['ipub-p5 mar-l-20 rotate ipub-cursor-pointer',!showReview?'rotate-180':'']"
                     type="iconArrow" />
        </div>
        <div class="mar-b-20 ipub-title-tab-part"
             v-if="!showReview">
          <ipub-form ref="reviews-commit"
                     v-show="!showReport"
                     :model="reviews"
                     :rules="rules">
            <div class="flex mar-b-10">
              <span class="ipub-p2 fw-bd">Decision <font class="key-color">*</font></span>
              <ipub-radio-group class="mar-l-12"
                                v-model="reviews.decisionStatus">
                <ipub-radio @change="changeStatus"
                            v-for="(value, key) in termList1"
                            :key="key"
                            :value="key">
                  <div style="margin-right:22px">{{ value }}</div>
                </ipub-radio>
              </ipub-radio-group>
            </div>
            <div class="flex mar-b-10 border-bottom"
                 style="padding-bottom:10px">
              <span class="ipub-p2 fw-bd">Review the Revised Manuscript <font class="key-color">*</font></span>
              <ipub-radio-group class="mar-l-12"
                                v-model="reviews.revised">
                <ipub-radio @change="changeManuscript"
                            key="Yes"
                            value="true">
                  <div style="margin-right:22px">Yes</div>
                </ipub-radio>
                <ipub-radio @change="changeManuscript"
                            key="No"
                            value="false">
                  <div style="margin-right:22px">No</div>
                </ipub-radio>
              </ipub-radio-group>
            </div>

            <div class="mar-b-12 border-bottom">
              <div class="ipub-p2 fw-bd fw-bd mar-b-8">
                Questionnaire
              </div>
              <ipub-row :gutter="30">
                <ipub-col v-for="(item,index) in reviews.questionList"
                          :key="item.questionId"
                          :span="6">
                  <div class="mar-b-10">
                    <div class="ipub-p2 mar-b-6">
                      <font v-if="item.required"
                            class="key-color">*</font>{{index+1}}.{{item.questionContent}}
                    </div>
                    <div v-if="item.type === 'QA'">
                      <ipub-input v-model.trim="item.answer"
                                  placeholder="Input your answer" />
                    </div>
                    <div v-else-if="item.type === 'SINGLE'">
                      <ipub-radio-group v-model="item.checkedOption">
                        <ipub-radio v-for="(val, num) in JSON.parse(item.questionOption)"
                                    :value="num"
                                    style="margin-bottom:8px;margin-left:0;margin-right:20px"
                                    :key="val.answer + num">
                          {{val.answer}}
                        </ipub-radio>
                      </ipub-radio-group>
                      <div v-if="(item.checkedOption || item.checkedOption===0) && JSON.parse(item.questionOption)[item.checkedOption].supplementary"
                           style="margin-top: 10px">
                        <div class="ipub-p2 mar-b-10">
                          {{JSON.parse(item.questionOption)[item.checkedOption].supplementary}}
                        </div>
                        <div>
                          <ipub-input v-model.trim="item.supplyAnswer"
                                      placeholder="Input your answer" />
                        </div>
                      </div>
                    </div>
                    <div v-else-if="item.type === 'MULTIPLE'">
                      <ipub-radio-group checkBox
                                        v-model="item.checkedOptions">
                        <ipub-radio checkBox
                                    v-for="(val, num) in JSON.parse(item.questionOption)"
                                    :value="val.answer"
                                    style="margin-bottom:8px"
                                    :key="val.answer + num">
                          {{val.answer}}
                        </ipub-radio>
                      </ipub-radio-group>
                    </div>
                  </div>
                </ipub-col>
              </ipub-row>
            </div>

            <div class="ipub-p2 fw-bd fw-bd mar-b-4">
              Comments to Author
              <font class="key-color">*</font>
              <ipub-tooltip type="dark"
                            placement="right">
                <div slot="title">If you are reviewing for the first time, you can click <a href="https://www.imrpress.com/resources/for_reviewers#3._managing_your_review"
                     target="_blank"
                     class="link-color">
                    here</a> for the review guide.</div>
                <ipub-icon type="iconInfo"
                           class="mar-l-5"></ipub-icon>
              </ipub-tooltip>
            </div>
            <div class="mar-b-30">
              <ipub-textarea placeholder="Comments to Author"
                             v-model.trim="reviews.authorNotes"
                             :autoSize="{ cols: '', rows: '10' }" />
            </div>

            <div class="ipub-p2 fw-bd fw-bd mar-b-4">
              Comments to Editor
            </div>
            <ipub-textarea placeholder="Comments to Editor"
                           class="mar-b-20"
                           v-model.trim="reviews.editorNotes"
                           :autoSize="{ cols: '', rows: '10' }" />
            <div class="ipub-p2 fw-bd fw-bd flex relative mar-b-12">
              <div>Attachment(s)</div>
              <div class="mar-l-20">
                <ipub-upload v-if="!loading"
                             @change="handleUpload"
                             class="ipub-c-p link-color"
                             multiple>
                  <ipub-icon type="iconAdd" /> Add New Review Document
                </ipub-upload>
                <font class="line-color"
                      v-else>
                  <ipub-icon :type="loading?'loading':'iconAdd'" /> Add New Review Document
                </font>
              </div>
            </div>

            <div class="flex mar-b-40">
              <!-- @click="download(index)" -->
              <ipub-label style="margin-right:6px"
                          class="ipub-cursor-pointer"
                          hover
                          :key="index"
                          v-for="(item,index) in dataSource">
                <span class="ipub-p2 border-right"
                      @click="download(item)">{{item.name}}<ipub-icon type="iconDownload1"
                             class="mar-l-10"></ipub-icon>
                </span>
                <ipub-icon :class="['ipub-p2 mar-l-10 rotate']"
                           @click="del(index)"
                           type="iconDelete" />
              </ipub-label>
            </div>
          </ipub-form>
        </div>
      </div>

    </div>
    <div class="mar-b-40">
      <ipub-button type="primary"
                   :style="{ minWidth: '150px' }"
                   @click="submit">Submit</ipub-button>
    </div>
    <Loading :isVisable="loading"
             @cancel="cancel"
             :progress="uploadProgress" />
  </div>
</template>



<script>
import main from './main'
export default main

</script>

<style lang="scss" scoped>
@import './main.scss';
</style>
